<template>
    <div class="flex flex-1 flex-col justify-center py-8 text-center">
        <p class="my-6 text-3xl font-normal md:text-5xl">
            Thanks for stopping by
        </p>
        <img
            src="/images/me.jpg"
            alt="Levi Zitting profile image"
            class="mx-auto block w-1/2 rounded-full"
        />
        <p class="mt-4">This is me</p>
        <p class="my-6 text-xl font-normal md:text-3xl">
            I code and sometimes write about it
        </p>
        <div class="my-6">
            <p class="text-xl font-normal md:text-3xl">
                I live in Springfield MO
            </p>
            <p class="text-xl font-normal md:text-3xl">
                where I work at
                <a
                    href="https://www.jackhenry.com/"
                    target="_blank"
                    class="text-text hover:text-text-muted underline transition-all duration-250 ease-in-out"
                >
                    Jack Henry
                </a>
            </p>
        </div>
        <p class="text-xl font-normal md:text-3xl">
            Here's a copy of my
            <a
                href="/documents/Levi_Zitting_Resume_2025.pdf"
                target="_blank"
                class="text-text hover:text-text-muted underline transition-all duration-250 ease-in-out"
            >
                resume
            </a>
        </p>
    </div>
</template>
